import { Drawer, Flex, Segmented, Typography } from 'antd';
import { WorkflowDTOType } from '../../../schemas';
import { useState } from 'react';
import ProductsTab from './ProductsTab';
import TagsTab from './TagsTab';

interface IViewProductsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  workflow: WorkflowDTOType | null;
}

const ViewProductsDrawer = ({ isOpen, onClose, workflow }: IViewProductsDrawerProps) => {
  const [activeTab, setActiveTab] = useState<'Products' | 'Tags'>('Products');

  return (
    <Drawer
      width={'75vw'}
      title={
        <Flex justify="space-between" align="center">
          <Typography.Paragraph style={{ margin: 0 }}>{workflow?.name}</Typography.Paragraph>
          <Segmented
            options={['Products', 'Tags']}
            value={activeTab}
            onChange={val => setActiveTab(val as 'Products' | 'Tags')}
          />
        </Flex>
      }
      open={isOpen}
      onClose={onClose}
      closable={false}
      destroyOnHidden
      size="large"
      styles={{
        content: {
          padding: '24px',
        },
        header: {
          border: '1px solid #F4F4F4',
          background: '#F9F9F9',
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
          padding: '16px',
        },
        body: {
          padding: '0px',
          borderLeft: '1px solid #F4F4F4',
          borderRight: '1px solid #F4F4F4',
          borderBottom: '1px solid #F4F4F4',
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        },
      }}
    >
      {activeTab === 'Products' ? (
        <ProductsTab workflow={workflow} />
      ) : (
        <TagsTab workflow={workflow} />
      )}
    </Drawer>
  );
};

export default ViewProductsDrawer;
